import { render } from "./preOrders.vue?vue&type=template&id=1776bd43&scoped=true"
import script from "./preOrders.vue?vue&type=script&lang=js"
export * from "./preOrders.vue?vue&type=script&lang=js"

import "./preOrders.vue?vue&type=style&index=0&id=1776bd43&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1776bd43"]])

export default __exports__